const angular = require('angular');
const app = angular.module('learn-directives');

/**
 * Defines the Sign In Directive which defines the sign in form behavior and markup
 * @argument {authorization} AuthorizationResource injected to access the authorization resource
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Analyze} Analyze injected to gain access to the Analyze resource
 */
app.directive('signinForm', ['AuthorizationResource', 'Application', 'Authorization', 'Analyze', 'Companies', 'Users', '$translate', 'i18n', function(AuthorizationResource, Application, Authorization, Analyze, Companies, Users, $translate, i18n) {
    return {
      restrict: 'E',
      template: require('../../../templates/directives/preauth/signin-form.html'),
      controller: function() {
        var self = this;
        self.credentials = {domain: Application.navigation.getHost(), email: '', password: ''};
        self.loading = false;
        self.newUser;
        self.ssoOption = false;
        self.useridOption = false;
        self.useridLimit;
        self.useridPattern;
        self.useridCopy;
        self.ssoLink = '';
        self.activeTab = 'sso';
        self.useNewWindow = Application.signinUseNewWindow;

        self.testEmail = function(){
          var testRE = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}/g;
          return !testRE.test(self.credentials.email);
        };

        self.pressEnter = function(keyPress) {
          if (self.loading || keyPress !== 'click' && keyPress.which !== 13) {
            return;
          }

          if (self.credentials.email && self.credentials.password) {
            self.signIn();
          }
        };

        self.registerAllow = Application.registerAllow;
        
        self.signIn = function() {
          self.loading = true;
          if (self.activeTab === 'userid') {
            delete self.credentials.email;
          }
          AuthorizationResource.signin({}, self.credentials, async function(data) {
            if (Authorization.validateAndUseAuthToken(data)) {
              self.loading = false;
              Authorization.setActive();
              Analyze.record({resource: 'useragents'}, {useragent: Application.userAgent});
              Analyze.record({resource: 'authtokens'}, {token: Authorization.getAuthToken().token, action: 'signin'});
              Application.analyticsProvider.trackEvent('signin');
              var redirectPath = Application.storage.get('preRedirect');
              var redirectParamsLogin = Application.storage.get('redirectParams') || {};
              Application.storage.remove('redirectParams');
              var redirect = {};
              if (redirectParamsLogin.integration) {
                redirect.integration = redirectParamsLogin.integration;
              }
              // LANGUAGE
              if (Authorization.getAuthToken() && Authorization.getAuthToken().user && Authorization.getAuthToken().user.language) {
                i18n.language(Authorization.getAuthToken().user.language);
              }

              if (redirectPath) {
                Application.storage.remove('preRedirect');
                Application.navigation.goTo(redirectPath, redirect);
                return;
              }
              Application.navigation.goToHome();
            }
          }, function(error) {
            self.loading = false;
            if (error && error.status === 401) {
              Application.messaging.addMessage({type: 'error', text: self.translations['preauth.signin.login_through_company_im'], duration: 5});
              // Application.messaging.addMessage({type: 'error', text: 'Please login through your company\'s identity manager.', duration: 5});
              Authorization.clearAuthToken();
              return;
            }
            Application.messaging.addMessage({type: 'error', text: self.translations['modules.notifications.invalidCredentials'], duration: 5});
            Authorization.clearAuthToken();
            Application.notifications.setError(self.translations['modules.notifications.invalidCredentials']);
          });
        };

        self.goTo = function(place) {
          Application.navigation.goTo(place, {});
        };

        // get company sso information
        self.companyChecked = false;
        var host = Application.companyDomain;
        Companies.checkAlternativeLogins({domain: host, authtoken: 'public'}).$promise
            .then(function(results) {
              if (results.suspended) {
                window.location.assign(window.location.origin + '/suspended');
                return;
              }
              // also returns type for use with LDAP down the line
              if (results.status && results.link) {
                self.ssoOption = true;
                self.ssoLink = results.link;
                self.ssoCopy = results.sso_copy || {};

                if (results.use_options) {
                  self.ssoLink = '/saml/login';
                }
                if (results.sso_landing_as_email) {
                  self.activeTab = 'email';
                }
              } else {
                self.activeTab = 'email';
              }
              
              self.useridOption = results.signin_userid;
              self.useridLimit = results.signin_userid_limit;
              self.useridPattern = results.signin_userid_pattern;
              self.useridCopy = results.signin_userid_copy;

              self.companyChecked = true;

              if (redirectChecked) {
                navigateRedirect();
              }
            }).catch(function(error) {
          console.log('error: ', error);
        });

        var navigateRedirect = function() {
          var statusOptions = {
            'inviting': true,
            'provisioning': true
          };
          if (!self.newUser || !self.newUser.provisioning_status || !statusOptions[self.newUser.provisioning_status.toLowerCase()]) {
            return;
          }

          if (self.newUser.provisioning_status === 'provisioning' && self.ssoLink) {
            var anchor = document.createElement('a');
            anchor.id = 'goto-sso';
            anchor.href = self.ssoLink;
            document.body.appendChild(anchor);
            document.getElementById('goto-sso').click();
            return;
          }

          if (self.newUser.provisioning_status === 'inviting' && self.newUser.provisioning_key) {
            Application.navigation.goTo('accept', {
              fname: self.newUser.first_name,
              lname: self.newUser.last_name,
              language: self.newUser.language || 'en',
              key: self.newUser.provisioning_key,
              email: self.email
            });
            return;
          }
        };

        $translate(['modules.notifications.invalidCredentials', 'preauth.signin.login_through_company_im']).then(function(data) {
          self.translations = data;
        });

        self.newWindow = function() {
          // Important to set child name as it is expected in the preauth-handler
          window.open(self.ssoLink, 'childsso', "target=_blank");
        };

        // Get user redirect information if applicable
        var redirectChecked = false;
        var redirectParams = Application.storage.get('redirectParams');
        if (redirectParams && redirectParams.email) {
          self.email = redirectParams.email && decodeURIComponent(redirectParams.email) ? decodeURIComponent(redirectParams.email).toLowerCase() : '';
          if (!self.email) {
            return;
          }

          Users.provisioningStatus({subresource: decodeURIComponent(redirectParams.email)}).$promise
              .then(function(user) {
                Application.storage.remove('redirectParams');
                if (!user.provisioning_status) {
                  return;
                }
                self.newUser = user;
                redirectChecked = true;
                if (self.companyChecked) {
                  navigateRedirect();
                }
              });
        }
      },
      controllerAs: 'signin'
    };
  }]);
